import {
  Component, Input
} from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})

export class TooltipComponent {
  constructor() { }

  @Input() text = '';

  @Input() boundaries?: ('viewport' | 'scrollParent' | 'window');

  @Input() hasTooltip = false;

  @Input() disablePointerEvent = true;

  @Input() minWidth = 'none';

  @Input() placement?: ('top' | 'bottom' | 'left' | 'right' | 'auto') = 'top';

  @Input() container = 'body';

  @Input() adaptivePosition = true;

  @Input() containerClass = '';

  @Input() insideModal = false;

  cssClass = '';

  ngOnInit(): void {
    if (this.insideModal) {
      this.cssClass = 'insideModal ';
    }
    this.cssClass += this.containerClass;
  }
}
